/**
 * Dropdown — Menu suspenso com itens clicáveis
 */
import { useState, useEffect, useRef } from 'preact/hooks';
import { T, CT } from '../../styles/tokens';

export interface DropdownItem {
  label: string;
  icon?: string;
  onClick: () => void;
  danger?: boolean;
}

interface DropdownProps {
  /** Elemento que abre o dropdown */
  trigger: any;
  /** Itens do menu */
  items: DropdownItem[];
  /** Alinhamento do menu */
  align?: 'left' | 'right';
}

export function Dropdown({ trigger, items, align = 'left' }: DropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Fechar ao clicar fora
  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const keyHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('keydown', keyHandler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('keydown', keyHandler);
    };
  }, [open]);

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <div onClick={() => setOpen(!open)} style={{ cursor: 'pointer' }}>
        {trigger}
      </div>
      {open && (
        <div style={{
          position: 'absolute',
          top: '100%',
          [align === 'right' ? 'right' : 'left']: 0,
          marginTop: T.space1,
          background: CT.dropdown.bg,
          border: `1px solid ${CT.dropdown.border}`,
          borderRadius: CT.dropdown.radius,
          boxShadow: CT.dropdown.shadow,
          zIndex: 9998,
          minWidth: 160,
          padding: `${T.space1}px 0`,
          overflow: 'hidden',
        }}>
          {items.map((item, i) => (
            <div
              key={i}
              onClick={() => { item.onClick(); setOpen(false); }}
              style={{
                padding: `${T.space2}px ${T.space4}px`,
                fontSize: T.textMd,
                color: item.danger ? T.danger : T.text,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: T.space2,
                transition: `background ${T.transitionFast}`,
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = CT.dropdown.itemHover)}
              onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
            >
              {item.icon && <span style={{ fontSize: T.textLg }}>{item.icon}</span>}
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
